import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from "@angular/core";

export enum MessageSeverity {
  Success,
  Info,
  Warning,
  Error,
  AVPColors
}

export enum MessageVariant {
  Filled,
  Outlined,
  Standart,
}

@Directive({
  selector: '[appMessageDirective]',
  standalone: true,
})
export class MessageDirective implements AfterViewInit{

  @Input()
  public variant: MessageVariant;

  @Input()
  public severity: MessageSeverity;

  /**
   * Add css classes separated by comma
   */
  @Input()
  public cssClass: string;

  constructor(private _renderer:Renderer2, private _el: ElementRef) {

  }

  ngAfterViewInit(): void {
    // Get parent of the original input element
    var parent = this._el.nativeElement.parentNode;

    // Create a div
    var divElement = this._renderer.createElement("div");
    this.setCssClasses(divElement);

    // Add the div, just before the element
    this._renderer.insertBefore(parent, divElement, this._el.nativeElement);

    // Remove the element
    this._renderer.removeChild(parent, this._el.nativeElement);

    //Add Icon
    var spanElement = this._renderer.createElement("span");
    this._renderer.addClass(spanElement, "e-msg-icon");
    if (this.severity == MessageSeverity.AVPColors) {
      this._renderer.addClass(spanElement, "avp-colors");
    }
    this._renderer.appendChild(divElement, spanElement);

    // Re-add text element inside the div
    this._renderer.appendChild(divElement, this._el.nativeElement);
    this._renderer.addClass(this._el.nativeElement, "e-msg-content");
  }

  private setCssClasses(divElement: any) {
    this._renderer.addClass(divElement, "e-control");
    this._renderer.addClass(divElement, "e-message");
    this._renderer.addClass(divElement, "e-lib");

    if (this.cssClass) {
      this.cssClass.split(",").forEach((cssClass) => {
        this._renderer.addClass(divElement, cssClass);
      });
    }

    switch (this.variant) {
      case MessageVariant.Filled:
        this._renderer.addClass(divElement, "e-filled");
        break;
      case MessageVariant.Outlined:
        this._renderer.addClass(divElement, "e-outlined");
        break;
    }

    switch (this.severity) {
      case MessageSeverity.Success:
        this._renderer.addClass(divElement, "e-success");
        break;
      case MessageSeverity.Info:
        this._renderer.addClass(divElement, "e-info");
        break;
      case MessageSeverity.Warning:
        this._renderer.addClass(divElement, "e-warning");
        break;
      case MessageSeverity.Error:
        this._renderer.addClass(divElement, "e-error");
        break;
      case MessageSeverity.AVPColors:
        this._renderer.addClass(divElement, "avp-colors");
        break;
    }
  }
}
